import React, { useState, useEffect} from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './hooks/useAuth';
import Navbar from './components/common/Navbar';
import Sidebar from './components/common/Sidebar';
import AppRoutes from './routes';
import useAuth from './hooks/useAuth';

// Composant de chargement
const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center min-vh-100">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Chargement...</span>
    </div>
  </div>
);

const useIsMobile = (breakpoint = 992) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return isMobile;
};

const Layout = () => {
  const { isAuthenticated, isFirstLogin, isLoading } = useAuth();
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  useEffect(() => { setSidebarOpen(!isMobile); }, [isMobile]);

  const toggleSidebar = () => setSidebarOpen((o) => !o);
  const closeSidebar = () => setSidebarOpen(false);

  if (isLoading) return <LoadingSpinner />;
  if (!isAuthenticated || isFirstLogin) return <AppRoutes />;

  return (
    <div className="d-flex">
      
      <Sidebar isOpen={sidebarOpen} isMobile={isMobile} onClose={closeSidebar} />

      {isMobile && sidebarOpen && (
        <div
          onClick={closeSidebar}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1040 }}
        />
      )}

      <div
        className="content-wrapper"
        style={{
          marginLeft: !isMobile && sidebarOpen ? '250px' : '0',
          width: !isMobile && sidebarOpen ? 'calc(100% - 250px)' : '100%',
          transition: 'margin-left 0.3s ease, width 0.3s ease',
          minHeight: '100vh',
        }}
      >
        <Navbar toggleSidebar={toggleSidebar} />
        <main className="p-3 p-md-4">
          <AppRoutes />
        </main>
      </div>
    </div>
  );
};


// Composant App principal
const App = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>   {/* ⬅ MODIF */}

      <AuthProvider>
        <Layout />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </AuthProvider>
    </Router>
  );
};

export default App;